// src/utils/authFetch.js
export const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem("token");

  const res = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (res.status === 401 || res.status === 403) {
    console.error("Authentication error: Token is invalid or expired. Redirecting to login page.");
    localStorage.removeItem("token");
    localStorage.removeItem("currentUser");
    window.location.href = "/login"; // redirect
    return new Promise(() => {});
  }

  return res;
};
